export default __webpack_public_path__ + "media/images/react_icons/whatsapp-ea088b3474504efedbe50c8494bebc86.svg";